import React, { useState } from "react";
import { Button } from "../../../../components/buttons/Button";
import { TemplateListItem } from "./TemplateListItem";
import { NoTemplate } from "./NoTemplate";
import { Template } from "../../../../../core/entities/template";

interface Props {
    header: string;
    selected: Template;
    templates: Template[];
    onSelect: (template: Template) => void;
    onEdit: (template: Template) => void;
    expandable: boolean;
    showUpTo?: number;
}

export function TemplateList({
    header,
    templates,
    onSelect,
    onEdit,
    expandable,
    selected,
    showUpTo = 0
}: Props) {
    const [show, setShow] = useState<boolean>(false);
    let temps = templates.sort(
        (a, b) => b.createdAt.getTime() - a.createdAt.getTime()
    );
    if (expandable && !show) {
        temps = temps.slice(0, showUpTo);
    }

    const members = temps.map((x) => (
        <TemplateListItem
            key={x.id}
            template={x}
            selected={selected.id === x.id}
            onSelect={() => onSelect(x)}
            onEdit={() => onEdit(x)}
        />
    ));
    return (
        <div>
            <p className={"text-sx text-placeholder-text mb-8"}>{header}</p>
            <ul className={"space-y-12 mb-12"}>
                {members.length ? members : <NoTemplate />}
            </ul>
            {expandable && templates.length > showUpTo && (
                <div className={"flex justify-center"}>
                    <Button
                        size={"m"}
                        theme={"tertiary"}
                        onClick={() => setShow((x) => !x)}
                    >
                        {show ? "Se færre" : "Se flere"}
                    </Button>
                </div>
            )}
        </div>
    );
}
